import { render, staticRenderFns } from "./PainelFinalizacaoAtendimento.vue?vue&type=template&id=73637d98&scoped=true&"
import script from "./PainelFinalizacaoAtendimento.vue?vue&type=script&lang=js&"
export * from "./PainelFinalizacaoAtendimento.vue?vue&type=script&lang=js&"
import style0 from "./PainelFinalizacaoAtendimento.vue?vue&type=style&index=0&id=73637d98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73637d98",
  null
  
)

export default component.exports